/**
 * Collections for diagram data
 * 
 * Note: Using simple in-memory storage instead of TanStack DB
 * for better compatibility. Yjs provides the reactive layer.
 */

import type { Shape, Connector } from '../schemas/diagramSchemas';

// Simple in-memory stores
export const shapesStore = new Map<string, Shape>();
export const connectorsStore = new Map<string, Connector>();

